
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sa/agenda-at-a-glance",
      function () {
        return require("private-next-pages/sa/agenda-at-a-glance.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sa/agenda-at-a-glance"])
      });
    }
  